import { BookOpen, CircleDashed, Lightbulb, MessageCircleQuestion, Quote, Shapes } from 'lucide-react';
import type { Estilo } from '@miolos/core';
import { DESCRICAO_ESTILO, ESTILOS, ROTULO_ESTILO } from '@miolos/core';
import { CartaoOpcao } from '@/components/CartaoOpcao';
import { useEditor } from '../EstadoEditor';
import { Grade, TituloPasso } from '../ui';

const ICONES: Record<Estilo, typeof BookOpen> = {
  DEVOCIONAL: BookOpen,
  MOTIVACIONAL: Quote,
  CURIOSIDADES: Lightbulb,
  PERGUNTAS: MessageCircleQuestion,
  ESTUDAR: Shapes,
  SEM_ESTILO: CircleDashed,
};

const O_QUE_ENTRA: Record<Estilo, string[]> = {
  DEVOCIONAL: [
    'Referência bíblica do dia',
    'Reflexão curta (texto original)',
    'Espaço para oração',
    'Três linhas de gratidão',
  ],
  MOTIVACIONAL: [
    'Frase do dia com ação prática',
    'Três prioridades com caixinhas',
    'Meta do dia (o que / como)',
    'Reflexão noturna',
  ],
  CURIOSIDADES: [
    'Um fato do mundo por dia (texto original)',
    'O porquê dele, explicado por dentro',
    'O que observar ou testar hoje',
    'Duas linhas para anotar o que você viu',
  ],
  PERGUNTAS: [
    'Uma pergunta por dia (texto original)',
    'O porquê dela, para começar a pensar',
    'Um passo de escrita, sem página em branco',
    'Três linhas para responder',
  ],
  ESTUDAR: [
    'Um desafio por dia (texto original)',
    'A pista de como chegar lá, sem entregar a resposta',
    'Uma palavra nova com o significado',
    'Duas linhas para usar a palavra numa frase',
  ],
  SEM_ESTILO: ['Só a estrutura de escrita', 'Uma coluna livre de pautas', 'Sem textos sugeridos'],
};

export function PassoEstilo() {
  const { config, atualizar } = useEditor();

  return (
    <div className="space-y-5">
      <TituloPasso
        titulo="Que tipo de conteúdo acompanha os dias?"
        descricao="O estilo adiciona uma coluna lateral com conteúdo pronto — ou deixa a página totalmente livre para você."
      />
      <Grade colunas={3}>
        {ESTILOS.map((estilo: Estilo) => {
          const Icone = ICONES[estilo];
          return (
            <CartaoOpcao
              key={estilo}
              selecionado={config.estilo === estilo}
              titulo={ROTULO_ESTILO[estilo]}
              descricao={DESCRICAO_ESTILO[estilo]}
              marca={<Icone className="size-5 text-primary" />}
              aoSelecionar={() => atualizar({ estilo })}
            >
              <ul className="space-y-1 pt-1">
                {O_QUE_ENTRA[estilo].map((item) => (
                  <li key={item} className="flex gap-2 text-xs text-muted-foreground">
                    <span className="mt-1.5 size-1 shrink-0 rounded-full bg-primary/60" />
                    {item}
                  </li>
                ))}
              </ul>
            </CartaoOpcao>
          );
        })}
      </Grade>

      <p className="rounded-md border border-border bg-muted/50 p-3 text-xs leading-relaxed text-muted-foreground">
        As reflexões devocionais, as frases motivacionais, as curiosidades e as perguntas foram
        escritas para este gerador. A escolha do conteúdo por dia é determinística: o mesmo dia sempre
        recebe o mesmo texto, então reimprimir dá exatamente o mesmo resultado.
      </p>
    </div>
  );
}
